export const categories = [
  { id: 'all', name: '全部服务', icon: 'ri-apps-line' },
  { id: 'consulting', name: '深夜咨询', icon: 'ri-customer-service-2-line' },
  { id: 'delivery', name: '凌晨配送', icon: 'ri-truck-line' },
  { id: 'support', name: '紧急支援', icon: 'ri-alert-line' },
  { id: 'life', name: '生活服务', icon: 'ri-home-heart-line' },
  { id: 'medical', name: '健康守护', icon: 'ri-heart-pulse-line' },
];

export const services = [
  {
    id: 1,
    category: 'consulting',
    name: '24小时在线心理咨询',
    description: '专业心理咨询师全天候在线，深夜情绪低落不再独自承受。无论凌晨几点，都有人愿意倾听你的心事，为你提供专业的心理疏导和支持。',
    price: '￥200/小时',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20counseling%20room%20at%20night%20with%20soft%20golden%20lamp%20light%2C%20two%20comfortable%20armchairs%2C%20gentle%20atmosphere%2C%20calming%20neutral%20colors%2C%20professional%20yet%20homey%20interior%2C%20night%20view%20through%20window&width=800&height=440&seq=service-consulting&orientation=landscape',
    tags: ['心理疏导', '情绪管理', '压力缓解'],
  },
  {
    id: 2,
    category: 'consulting',
    name: '法律咨询热线',
    description: '遇到紧急法律问题？我们的律师团队24小时待命，随时为你提供专业的法律意见和建议，关键时刻给你最可靠的法律保障。',
    price: '￥300/次',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20law%20office%20at%20night%20with%20warm%20desk%20lamp%20lighting%2C%20legal%20books%20on%20shelves%2C%20clean%20modern%20interior%2C%20trustworthy%20atmosphere%2C%20soft%20ambient%20glow%2C%20professional%20setting&width=800&height=440&seq=service-law&orientation=landscape',
    tags: ['法律咨询', '合同审查', '权益保护'],
  },
  {
    id: 3,
    category: 'consulting',
    name: '深夜学习辅导',
    description: '考试前夕需要冲刺？作业遇到难题？资深导师深夜在线一对一辅导，帮你攻克学习难关，让深夜成为你弯道超车的最佳时机。',
    price: '￥150/小时',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20study%20room%20at%20night%20with%20warm%20desk%20light%2C%20books%20and%20laptop%20on%20wooden%20desk%2C%20comfortable%20chair%2C%20soft%20ambient%20glow%2C%20peaceful%20learning%20atmosphere%2C%20night%20sky%20through%20window&width=800&height=440&seq=service-tutor&orientation=landscape',
    tags: ['学业辅导', '考试冲刺', '作业帮助'],
  },
  {
    id: 4,
    category: 'delivery',
    name: '凌晨急送服务',
    description: '急需文件、药品、生活用品？我们的骑手24小时待命，全城覆盖，最快30分钟送达。深夜急需不再无助，凌晨配送使命必达。',
    price: '￥25起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delivery%20rider%20on%20scooter%20at%20night%20city%20street%20with%20warm%20street%20lights%2C%20urban%20night%20scene%2C%20glowing%20city%20buildings%20in%20background%2C%20motion%20blur%2C%20cinematic%20night%20photography%2C%20warm%20golden%20tones&width=800&height=440&seq=service-express&orientation=landscape',
    tags: ['同城急送', '药品配送', '文件速递'],
  },
  {
    id: 5,
    category: 'delivery',
    name: '深夜美食配送',
    description: '凌晨饿了怎么办？合作商户全天候供应热食，从下单到送达全程保温，让你深夜也能享受热腾腾的美食，填饱肚子也温暖心灵。',
    price: '￥15起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20steaming%20hot%20food%20in%20takeout%20container%20on%20wooden%20table%20at%20night%2C%20cozy%20kitchen%20lighting%2C%20appetizing%20noodles%20and%20soup%2C%20soft%20golden%20glow%2C%20comfort%20food%20photography%2C%20homey%20atmosphere&width=800&height=440&seq=service-food&orientation=landscape',
    tags: ['深夜食堂', '热食配送', '全天候供应'],
  },
  {
    id: 6,
    category: 'delivery',
    name: '生鲜凌晨直达',
    description: '凌晨采摘、清晨送达，最新鲜的蔬菜水果直接从产地到你家。比超市更新鲜、比菜市场更方便，让你每天都能享受第一手鲜甜。',
    price: '￥30起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20colorful%20vegetables%20and%20fruits%20in%20wooden%20crate%20at%20early%20morning%20farm%20market%2C%20soft%20dawn%20light%2C%20dew%20drops%20on%20produce%2C%20organic%20farm%20aesthetic%2C%20fresh%20and%20vibrant%20colors%2C%20natural%20morning%20glow&width=800&height=440&seq=service-fresh&orientation=landscape',
    tags: ['生鲜配送', '产地直供', '清晨直达'],
  },
  {
    id: 7,
    category: 'support',
    name: '紧急维修服务',
    description: '水管爆了、电路跳闸、门锁坏了？深夜突发故障不要慌，专业维修师傅24小时待命，最快20分钟上门，解决你的燃眉之急。',
    price: '￥100起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20repair%20technician%20working%20with%20tools%20in%20modern%20home%20at%20night%2C%20warm%20indoor%20lighting%2C%20focused%20on%20fixing%20pipe%2C%20clean%20uniform%2C%20trustworthy%20professional%20atmosphere%2C%20soft%20ambient%20glow&width=800&height=440&seq=service-repair&orientation=landscape',
    tags: ['水电维修', '家电修理', '紧急开锁'],
  },
  {
    id: 8,
    category: 'support',
    name: 'IT技术支持',
    description: '服务器宕机、网站崩溃、数据丢失？技术团队7×24小时在线响应，随时为你排查故障、恢复系统，保障你的业务永不掉线。',
    price: '￥500起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20tech%20support%20workstation%20at%20night%20with%20multiple%20monitors%20displaying%20code%2C%20keyboard%20with%20warm%20backlight%2C%20server%20room%20background%2C%20professional%20IT%20environment%2C%20blue%20and%20warm%20amber%20contrast%20lighting&width=800&height=440&seq=service-it&orientation=landscape',
    tags: ['服务器维护', '故障排查', '数据恢复'],
  },
  {
    id: 9,
    category: 'life',
    name: '深夜家政服务',
    description: '加班到深夜回家还要打扫？我们提供深夜保洁服务，在你入睡时悄悄打扫，醒来看到焕然一新的家。让深夜不再是疲惫的延续。',
    price: '￥120/次',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20living%20room%20at%20night%20with%20warm%20soft%20lighting%2C%20vacuum%20cleaner%20and%20cleaning%20supplies%2C%20sparkling%20clean%20surfaces%2C%20cozy%20home%20atmosphere%2C%20peaceful%20night%20mood%2C%20organized%20and%20tidy%20space&width=800&height=440&seq=service-cleaning&orientation=landscape',
    tags: ['深夜保洁', '家庭清洁', '收纳整理'],
  },
  {
    id: 10,
    category: 'life',
    name: '宠物深夜看护',
    description: '出差在外担心毛孩子？凌晨宠物突发不适？专业宠物护理师24小时在岗，提供上门喂养、遛弯、基础医疗护理等全方位宠物服务。',
    price: '￥80/次',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20fluffy%20cat%20and%20small%20dog%20resting%20on%20soft%20blanket%20at%20night%2C%20warm%20cozy%20home%20interior%2C%20gentle%20lamp%20light%2C%20peaceful%20sleeping%20pets%2C%20loving%20pet%20care%20atmosphere%2C%20soft%20golden%20tones&width=800&height=440&seq=service-pet&orientation=landscape',
    tags: ['宠物看护', '上门喂养', '遛狗服务'],
  },
  {
    id: 11,
    category: 'medical',
    name: '在线问诊服务',
    description: '深夜身体不适不知道去哪看？三甲医院医生在线接诊，图文+视频问诊，快速判断病情、开具处方，让你深夜也能获得专业医疗指导。',
    price: '￥50/次',
    imageUrl: 'https://readdy.ai/api/search-image?query=Doctor%20consulting%20via%20video%20call%20on%20laptop%20at%20night%2C%20warm%20home%20office%20setting%2C%20stethoscope%20on%20desk%2C%20professional%20medical%20atmosphere%2C%20caring%20healthcare%20theme%2C%20soft%20ambient%20lighting&width=800&height=440&seq=service-doctor&orientation=landscape',
    tags: ['在线问诊', '用药指导', '健康咨询'],
  },
  {
    id: 12,
    category: 'medical',
    name: '夜间护理服务',
    description: '家里有术后康复或长期卧床的病人需要夜间护理？专业护士24小时上门服务，提供翻身拍背、管路护理、生命体征监测等专业照护。',
    price: '￥200/晚',
    imageUrl: 'https://readdy.ai/api/search-image?query=Caring%20nurse%20in%20soft%20uniform%20checking%20on%20patient%20in%20comfortable%20bedroom%20at%20night%2C%20warm%20bedside%20lamp%2C%20gentle%20professional%20healthcare%20atmosphere%2C%20peaceful%20healing%20environment%2C%20soft%20golden%20tones&width=800&height=440&seq=service-nurse&orientation=landscape',
    tags: ['术后护理', '夜间陪护', '康复指导'],
  },
];